import { create } from "zustand";

export interface IAppSnackbar {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;

  title?: string;
  setTitle: (val: string | undefined) => void;

  body?: string;
  setBody: (val: string | undefined) => void;

  showIcon: boolean;    
  setShowIcon(show: boolean): void;
}

const useAppSnackbar = create<IAppSnackbar>((set, get) => ({
  isOpen: false,
  setOpen: (isOpen: boolean) => set({ isOpen }),

  title: undefined,
  setTitle: (title: string | undefined) => set({ title }),

  body: undefined,
  setBody: (body: string | undefined) => set({ body }),

  showIcon: true,
  setShowIcon: showIcon => set({ showIcon }),
}));

export default useAppSnackbar;
